import React from "react";
import LazyImage from "ui/LazyImage/LazyImage";
import { LinkProps } from "helpers/url";
import ImagePlaceholder from "./components/ImagePlaceholder/ImagePlaceholder";

export type ProductPreviewImage = "regular" | "horizontalSmall" | "horizontal";

type Props = {
  src?: string;
  linkProps?: LinkProps;
  type?: ProductPreviewImage;
  onClick?: () => void;
  className?: string;
  priority?: boolean;
  ariaLabel?: string;
  onMouseDown?: (event: React.MouseEvent) => void;
  title?: string;
  alt?: string;
};

const ProductPreviewImage: React.FC<Props> = ({ src, type, ...other }) => {
  return src ? (
    <LazyImage src={src} {...other} />
  ) : (
    <ImagePlaceholder type={type} {...other} />
  );
};

export default ProductPreviewImage;
